import { BaseService, Service } from "/@/cool";
@Service("dealerShopAgentApply")
class dealerShopAgentApply extends BaseService {
	constructor() {
		super();
		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		// this.permission["add"] = prefix + "add";
		// this.permission["update"] = prefix + "update";
		// this.permission["info"] = prefix + "info";
		this.permission["page"] = prefix + "page";
		this.permission["check"] = prefix + "check";
	}
	check(params: any) {
		return this.request({
			url: "/check",
			method: "POST",
			data: { ...params }
		});
	}
}
export default dealerShopAgentApply;
